import { setting } from '@/api/services'
import { sync } from '@/api/bosync'
import { common } from '@/api/common'
import store from '@/store'


let res = null

export const settings = {
    namespaced: true,
    state: {
        branchAddress: null,

        //기관 차량정보
        branchVehicle: null,
        vehicleMaintain: null,
        // maintainYear: null,
        vehicleOperation: null,
        // operationYear: null,
        staffList: [],

        //기관 배상책임보험
        staffLiabilityInsurance: null,
        insuranceStaffList: null,

        //기관 권한그룹
        permissionGroupMenus: null,

        //기관 급여설정정보
        branchSalary: null,

        //수급계약 조항설정
        commonCare: null,
        commonBath: null,
        commonNurse: null,

        //근로계약 조항설정
        partTime: null,
        regular: null,
        temporary: null,

        //운영위원회 조항설정
        steeringCommittee: null,

        //동기화 결과 조회
        syncings: null,
        syncRecipients: null,
        syncEmployees: null,
        syncSchedules: null,
        syncRFIDs: null,
        syncEmployments: null,
        syncPayslips: null,

        //물품목록설정(의약품)
        medicineList: null,

        //기관 휴가설정관리
        branchHoliday: null,
        branchVacation: null,
        vacationPolicy: null,

        //기관 계좌정보관리
        branchAccount: null,

        //4대보험요율
        deduct4Insurance: null,

        //서비스별 수가
        bathNumber: null,
        careNumber: null,
        nurseNumber: null,

        //시간대별 가산수가
        numberHourly: null,

        //수가 기타가산설정
        cognitiveList: null,
        distanceList: null,
        managerList: null,

        //맘스비 이용료
        serviceFeeList: null,
        customerMemo: null
    },
    mutations: {
        BRANCH_ADDRESS(state, payload) {
            state.branchAddress = payload.addressListInfo
        },
        REGIST_BRANCH_ADDRESS(state, payload) {
            if (!state.branchAddress) {
                state.branchAddress = []
            }
            if (state.branchAddress && state.branchAddress.length !== 0) {
                let index = state.branchAddress.findIndex(item => item.defaultYn === 'Y')
                state.branchAddress[index].defaultYn = 'N'
            }
            state.branchAddress.unshift(payload.mapVO)
        },
        DEFAULT_ADDRESS(state, payload) {
            let index = state.branchAddress.findIndex(item => item.defaultYn === 'Y')
            state.branchAddress[index].defaultYn = 'N'
            state.branchAddress[payload].defaultYn = 'Y'
        },
        UPDATE_ADDRESS(state, payload) {
            state.branchAddress.splice(payload.index, 1, payload.info.mapVO)
        },
        DELETE_ADDRESS(state, payload) {
            state.branchAddress.splice(payload, 1)
        },
        BRANCH_VEHICLE(state, payload) {
            state.branchVehicle = payload.carInfoList
        },
        REGIST_BRANCH_VEHICLE(state, payload) {
            if (!state.branchVehicle) {
                state.branchVehicle = []
            }
            state.branchVehicle.unshift(payload.carInfo)
        },
        UPDATE_BRANCH_VEHICLE(state, payload) {
            let index = state.branchVehicle.findIndex(item => item.carInfoIdx === payload.idx)
            if (index !== -1) state.branchVehicle.splice(index, 1, payload.info)
        },
        DELETE_BRANCH_VEHICLE(state, payload) {
            let index = state.branchVehicle.findIndex(item => item.carInfoIdx === payload)
            if (index !== -1) state.branchVehicle.splice(index, 1)
            if (state.branchVehicle.length === 0) state.branchVehicle = null
        },
        VEHICLE_MAINTAIN(state, payload) {
            state.vehicleMaintain = payload.maintenanceList
        },
        REGIST_VEHICLE_MAINTAIN(state, payload) {
            if (!state.vehicleMaintain) state.vehicleMaintain = []
            state.vehicleMaintain.unshift(payload.maintenanceInfo)
        },
        UPDATE_VEHICLE_MAINTAIN(state, payload) {
            let index = state.vehicleMaintain.findIndex(item => item.carMaintenanceIdx === payload.midx)
            state.vehicleMaintain.splice(index, 1, payload.info)
        },
        DELETE_VEHICLE_MAINTAIN(state, payload) {
            let index = state.vehicleMaintain.findIndex(item => item.carMaintenanceIdx === payload)
            state.vehicleMaintain.splice(index, 1)
            if (state.vehicleMaintain.length === 0) state.vehicleMaintain = null
        },
        DELETE_MAINTAIN_FILE(state, payload) {
            let index = state.vehicleMaintain.findIndex(item => item.carMaintenanceIdx === payload)
            state.vehicleMaintain[index].commonAttachFileIdx = null
        },
        VEHICLE_OPERATION(state, payload) {
            state.staffList = payload.staffList
            state.vehicleOperation = payload.carHisList
            if (!state.staffList) state.staffList = []
        },
        REGIST_VEHICLE_OPERATION(state, payload) {
            if (!state.vehicleOperation) state.vehicleOperation = []
            state.vehicleOperation.unshift(payload.operationHistory)
        },
        UPDATE_VEHICLE_OPERATION(state, payload) {
            let index = state.vehicleOperation.findIndex(item => item.carOperationHistoryIdx === payload.hidx)
            state.vehicleOperation.splice(index, 1, payload.info)
        },
        DELETE_VEHICLE_OPERATION(state, payload) {
            let index = state.vehicleOperation.findIndex(item => item.carOperationHistoryIdx === payload)
            state.vehicleOperation.splice(index, 1)
            if (state.vehicleOperation.length === 0) state.vehicleOperation = null
        },
        // SET_OPERATION_YEAR(state, payload) {
        //     state.operationYear = payload
        // },
        // SET_MAINTAIN_YEAR(state, payload) {
        //     state.maintainYear = payload
        // },
        BRANCH_INSURANCE(state, payload) {
            state.staffLiabilityInsurance = payload.staffLiabilityInsurance
        },
        INSURANCE_STAFF_LIST(state, payload) {
            state.insuranceStaffList = payload.insuranceStaffList
        },
        REGIST_INSURANCE_STAFF(state, payload) {
            if (state.staffLiabilityInsurance) {
                let index = state.staffLiabilityInsurance.findIndex(item => item.liabilityInsuranceIdx === payload.idx)
                let count = 0
                payload.info.forEach(item => {
                    if (item.liabilityInsuranceYn === 'Y') {
                        count += 1
                    }
                })
                state.staffLiabilityInsurance[index].joinCurrentCount = count
            }
        },
        // REGIST_BRANCH_INSURANCE(state, payload) {
        //     if(payload.idx) {
        //         let index = state.staffLiabilityInsurance.findIndex(item => item.liabilityInsuranceIdx === payload.idx)
        //         state.staffLiabilityInsurance.splice(index, 1, payload.info)
        //     } else {
        //         if(!state.staffLiabilityInsurance) state.staffLiabilityInsurance = []
        //         state.staffLiabilityInsurance.unshift(payload.info)
        //     }
        // },
        DELETE_INSURANCE_FILE(state, payload) {
            let index = state.staffLiabilityInsurance.findIndex(item => item.liabilityInsuranceIdx === payload)
            state.staffLiabilityInsurance[index].insurancePolicyFileIdx = null
        },
        BRANCH_PERMISSION(state, payload) {
            state.permissionGroupMenus = payload.permissionGroupMenus
        },
        REGIST_BRANCH_PERMISSION(state, payload) {
            state.permissionGroupMenus = payload.permissionGroupMenus
        },
        DELETE_BRANCH_PERMISSION(state, payload) {
            state.permissionGroupMenus.splice(payload, 1)
        },
        ADD_TEMP_PERMISSION(state, payload) {
            payload['permissionGroupIdx'] = 0
            payload['groupCode'] = '144'
            payload['detailCode'] = '35'
            state.permissionGroupMenus.push(payload)
        },
        DELETE_TEMP_PERMISSION(state, payload) {
            state.permissionGroupMenus.splice(payload, 1)
        },
        BRANCH_SALARY(state, payload) {
            state.branchSalary = payload.salarySettingList
        },
        UPDATE_BRANCH_SALARY(state, payload) {
            if (payload && payload.salarySettingList)
                state.branchSalary.unshift(payload.salarySettingList)
        },
        BRANCH_SERVICE_CONTRACT(state, payload) {
            state.commonCare = payload.commonCare,
                state.commonBath = payload.commonBath,
                state.commonNurse = payload.commonNurse
        },
        UPDATE_BRANCH_SERVICE_CONTRACT(state, payload) {
            state.commonCare = payload.commonCare,
                state.commonBath = payload.commonBath,
                state.commonNurse = payload.commonNurse
        },
        BRANCH_CONTRACT(state, payload) {
            state.partTime = payload.partTime,
                state.regular = payload.regular,
                state.temporary = payload.temporary
        },
        UPDATE_BRANCH_CONTRACT(state, payload) {
            state.partTime = payload.partTime,
                state.regular = payload.regular,
                state.temporary = payload.temporary
        },
        STEERING_COMMITTEE(state, payload) {
            state.steeringCommittee = payload.steeringCommitteeFormList
        },
        UPDATE_STEERING_COMMITTEE(state, payload) {
            state.steeringCommittee = payload.steeringCommitteeFormList
        },
        SYNCING_LIST(state, payload) {
            state.syncings = payload.uploadResult
        },
        MEDICINE_INFO(state, payload) {
            state.medicineList = payload.medicineInfo
        },
        REGIST_MEDICINE_INFO(state, payload) {
            if (!state.medicineList) state.medicineList = []
            let index = state.medicineList.findIndex(item => item.medicineInfoIdx === payload.medicineInfo.medicineInfoIdx)
            console.log(index)
            if (index === -1) {
                // if(!state.medicineList) state.medicineList = []
                state.medicineList.unshift(payload.medicineInfo)
            } else {
                state.medicineList.splice(index, 1, payload.medicineInfo)
            }
        },
        DELETE_MEDICINE_INFO(state, payload) {
            let index = state.medicineList.findIndex(item => item.medicineInfoIdx === payload)
            state.medicineList.splice(index, 1)
            if (!state.medicineList.length) state.medicineList = null
        },
        BRANCH_HOLIDAY(state, payload) {
            state.branchHoliday = payload.holidayList
        },
        REGIST_BRANCH_HOLIDAY(state, payload) {
            if (state.branchHoliday) {
                let index = state.branchHoliday.findIndex(item => item.customerHolidayIdx === payload.data.holidaySettingVO.customerHolidayIdx)
                if (index === -1) {
                    if (payload.data.holidaySettingVO.ym.substr(0, 4) === payload.date) {
                        if (!state.branchHoliday) state.branchHoliday = []
                        state.branchHoliday.unshift(payload.data.holidaySettingVO)
                    }
                } else {
                    state.branchHoliday.splice(index, 1, payload.data.holidaySettingVO)
                }
            } else {
                if (payload.data.holidaySettingVO.ym.substr(0, 4) === payload.date) {
                    if (!state.branchHoliday) state.branchHoliday = []
                    state.branchHoliday.unshift(payload.data.holidaySettingVO)
                }
            }
        },
        DELETE_BRANCH_HOLIDAY(state, payload) {
            let index = state.branchHoliday.findIndex(item => item.customerHolidayIdx === payload)
            state.branchHoliday.splice(index, 1)
            if (!state.branchHoliday.length) state.branchHoliday = null
        },
        BRANCH_VACATION_TYPE(state, payload) {
            state.branchVacation = payload.vacationTypeList
        },
        REGIST_BRANCH_VACATION_TYPE(state, payload) {
            if (state.branchVacation) {
                let index = state.branchVacation.findIndex(item => item.customerVacationTypeIdx === payload.vacationTypeVO.customerVacationTypeIdx)
                if (index === -1) {
                    if (!state.branchVacation) state.branchVacation = []
                    state.branchVacation.unshift(payload.vacationTypeVO)
                } else {
                    state.branchVacation.splice(index, 1, payload.vacationTypeVO)
                }
            } else {
                if (!state.branchVacation) state.branchVacation = []
                state.branchVacation.unshift(payload.vacationTypeVO)
            }
        },
        DELETE_BRANCH_VACATION_TYPE(state, payload) {
            let index = state.branchVacation.findIndex(item => item.customerVacationTypeIdx === payload)
            state.branchVacation.splice(index, 1)
            if (!state.branchVacation.length) state.branchVacation = null
        },
        BRANCH_VACATION_POLICY(state, payload) {
            state.vacationPolicy = payload.vacationPolicyInfo
        },
        REGIST_VACATION_POLICY(state, payload) {
            state.vacationPolicy = payload.vacationPolicyInfo
        },
        BRANCH_ACCOUNT(state, payload) {
            state.branchAccount = payload.customerBankAccountList
            if (state.branchAccount) {
                state.branchAccount.forEach(item => {
                    item.secPno = item.secPno ? atob(decodeURIComponent(item.secPno)) : null
                    item.birthPno = item.birthPno ? atob(decodeURIComponent(item.birthPno)) : null
                    item.bankUserPw = item.bankUserPw ? atob(decodeURIComponent(item.bankUserPw)) : null
                })
            }
        },
        REGIST_BRANCH_ACCOUNT(state, payload) {
            if (!state.branchAccount) state.branchAccount = []
            let index = state.branchAccount.findIndex(item => item.customerBankAccountIdx === payload.customerBankAccount.customerBankAccountIdx)
            if (index === -1) {
                state.branchAccount.unshift(payload.customerBankAccount)
                state.branchAccount[0].secPno =
                    state.branchAccount[0].secPno ? atob(decodeURIComponent(state.branchAccount[0].secPno)) : null
                state.branchAccount[0].birthPno =
                    state.branchAccount[0].birthPno ? atob(decodeURIComponent(state.branchAccount[0].birthPno)) : null
                state.branchAccount[0].bankUserPw =
                    state.branchAccount[0].bankUserPw ? atob(decodeURIComponent(state.branchAccount[0].bankUserPw)) : null
            } else {
                state.branchAccount.splice(index, 1, payload.customerBankAccount)
                state.branchAccount[index].secPno =
                    state.branchAccount[index].secPno ? atob(decodeURIComponent(state.branchAccount[index].secPno)) : null
                state.branchAccount[index].birthPno =
                    state.branchAccount[index].birthPno ? atob(decodeURIComponent(state.branchAccount[index].birthPno)) : null
                state.branchAccount[index].bankUserPw =
                    state.branchAccount[index].bankUserPw ? atob(decodeURIComponent(state.branchAccount[index].bankUserPw)) : null
            }
        },
        DELETE_BRANCH_ACCOUNT(state, payload) {
            let index = state.branchAccount.findIndex(item => item.customerBankAccountIdx === payload)
            console.log(index)
            state.branchAccount.splice(index, 1)
            if (!state.branchAccount.length) state.branchAccount = null
        },
        DEDUCT_INSURANCE(state, payload) {
            state.deduct4Insurance = payload.list
        },
        SALARY_NUMBER(state, payload) {
            state.bathNumber = payload.bathNumberList
            state.careNumber = payload.careNumberList
            state.nurseNumber = payload.nurseNumberList
        },
        NUMBER_HOURLY(state, payload) {
            state.numberHourly = payload.numberHourlyAddList
        },
        STANDARD_SALARY(state, payload) {
            state.cognitiveList = payload.cognitiveActivityAddList,
                state.distanceList = payload.longDistinceAddList,
                state.managerList = payload.programManagerAddList
        },
        PROD_SERVICE_FEE(state, payload) {
            state.serviceFeeList = payload.feeList
        },
        CUSTOMER_MEMO(state, payload) {
            state.customerMemo = payload.boCustomerMemoList
        },
        REGIST_CUSTOMER_MEMO(state, payload) {
            if(!state.customerMemo) state.customerMemo = []
            state.customerMemo.unshift(payload.memoVO)
        },
        DELETE_CUSTOMER_MEMO(state, payload) {
            let index = state.customerMemo.findIndex(item => item.boCustomerMemoIdx === payload)
            if(index !== -1) {
                state.customerMemo.splice(index, 1)
            }
            if(!state.customerMemo.length) state.customerMemo = null
        },
        UPDATE_CUSTOMER_MEMO(state, payload) {
            let index = state.customerMemo.findIndex(item => item.boCustomerMemoIdx === payload.idx)
            if(index !== -1) {
                state.customerMemo.splice(index, 1, payload.memo.memoVO)
            }
        }
    },
    actions: {
        // @Description 기관주소 조회
        async BRANCH_ADDRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.mapList(payload)
                console.log('BRANCH_ADDRESS info', res)
                if (res.data.status === 200) {
                    commit('BRANCH_ADDRESS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_ADDRESS error', error)
            }
        },
        // @Description 기관주소 등록
        async REGIST_BRANCH_ADDRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.map(payload)
                console.log('REGIST_BRANCH_ADDRESS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_BRANCH_ADDRESS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_BRANCH_ADDRESS error', error)
            }
        },
        // @Description 기관 기본주소 설정
        async DEFAULT_ADDRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.baseMap(payload)
                console.log('DEFAULT_ADDRESS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DEFAULT_ADDRESS', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DEFAULT_ADDRESS error', error)
            }
        },
        // @Description 기관 주소정보 수정
        async UPDATE_ADDRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.mapUpdate(payload)
                console.log('UPDATE_ADDRESS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_ADDRESS', { info: res.data.data, index: payload.index })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_ADDRESS error', error)
            }
        },
        // @Description 기관주소정보 삭제
        async DELETE_ADDRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.delete.map(payload)
                console.log('DELETE_ADDRESS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_ADDRESS', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_ADDRESS error', error)
            }
        },
        // @Description 운영규정관리 idx 조회
        async OPERATION_RULE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.operationRule(payload)
                console.log('OPERATION_RULE info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('OPERATION_RULE error', error)
            }
        },
        // @Description 기관차량 조회
        async BRANCH_VEHICLE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.car(payload)
                console.log('BRANCH_VEHICLE info', res)
                if (res.data.status === 200) {
                    commit('BRANCH_VEHICLE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_VEHICLE error', error)
            }
        },
        // @Description 기관차량 등록
        async REGIST_BRANCH_VEHICLE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.car(payload)
                console.log('REGIST_BRANCH_VEHICLE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_BRANCH_VEHICLE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_BRANCH_VEHICLE error', error)
            }
        },
        // @Description 기관차량 수정
        async UPDATE_BRANCH_VEHICLE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.carUpdate(payload)
                console.log('UPDATE_BRANCH_VEHICLE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_BRANCH_VEHICLE', {
                        idx: payload.idx,
                        info: res.data.data.carInfo
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_BRANCH_VEHICLE error', error)
            }
        },
        // @Description 기관차량 삭제
        async DELETE_BRANCH_VEHICLE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.delete.car(payload)
                console.log('DELETE_BRANCH_VEHICLE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_BRANCH_VEHICLE', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_BRANCH_VEHICLE error', error)
            }
        },
        // @Description 차량 소독일지 조회
        async BATH_DISINFECTION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.carDisinfectPrint(payload)
                console.log('BATH_DISINFECTION info', res)
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BATH_DISINFECTION error', error)
            }
        },
        // @Description 차량 정비이력
        async VEHICLE_MAINTAIN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.maintain(payload)
                console.log('VEHICLE_MAINTAIN info', res)
                if (res.data.status === 200) {
                    commit('VEHICLE_MAINTAIN', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('VEHICLE_MAINTAIN error', error)
            }
        },
        // @Description 차량 정비일지 등록
        async REGIST_VEHICLE_MAINTAIN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.maintain(payload)
                console.log('REGIST_VEHICLE_MAINTAIN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_VEHICLE_MAINTAIN', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_VEHICLE_MAINTAIN error', error)
            }
        },
        // @Description 차량 정비일지 수정
        async UPDATE_VEHICLE_MAINTAIN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.maintainUpdate(payload)
                console.log('UPDATE_VEHICLE_MAINTAIN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_VEHICLE_MAINTAIN', {
                        info: res.data.data.maintenanceList,
                        midx: payload.midx
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_VEHICLE_MAINTAIN error', error)
            }
        },
        // @Description 차량 정비일지 삭제
        async DELETE_VEHICLE_MAINTAIN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.delete.maintain(payload)
                console.log('DELETE_VEHICLE_MAINTAIN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_VEHICLE_MAINTAIN', payload.midx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_VEHICLE_MAINTAIN error', error)
            }
        },
        // @Description 차량 정비이력 파일삭제
        async DELETE_MAINTAIN_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_MAINTAIN_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MAINTAIN_FILE', payload.midx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MAINTAIN_FILE error', error)
            }
        },
        // @Description 차량 운행이력
        async VEHICLE_OPERATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.operation(payload)
                console.log('VEHICLE_OPERATION info', res)
                if (res.data.status === 200) {
                    commit('VEHICLE_OPERATION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('VEHICLE_OPERATION error', error)
            }
        },
        // @Description 차량 운행이력 등록
        async REGIST_VEHICLE_OPERATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.operation(payload)
                console.log('REGIST_VEHICLE_OPERATION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_VEHICLE_OPERATION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_VEHICLE_OPERATION error', error)
            }
        },
        // @Description 차량 운행이력 수정
        async UPDATE_VEHICLE_OPERATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.operationUpdate(payload)
                console.log('UPDATE_VEHICLE_OPERATION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_VEHICLE_OPERATION', {
                        info: res.data.data.operationHistory,
                        hidx: payload.hidx
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_VEHICLE_OPERATION error', error)
            }
        },
        // @Description 차량 운행이력 삭제
        async DELETE_VEHICLE_OPERATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.delete.operation(payload)
                console.log('DELETE_VEHICLE_OPERATION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_VEHICLE_OPERATION', payload.hidx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_VEHICLE_OPERATION error', error)
            }
        },
        // @Description 기관 배상책임보험 조회(리스트)
        async BRANCH_INSURANCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.insurance(payload)
                console.log('BRANCH_INSURANCE info', res)
                if (res.data.status === 200) {
                    commit('BRANCH_INSURANCE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_INSURANCE error', error)
            }
        },
        async BRANCH_INSURANCE_SELECT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.insurance(payload)
                console.log('BRANCH_INSURANCE_SELECT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_INSURANCE_SELECT error', error)
            }
        },
        // @Description 기관 배상책임보험 직원 리스트 조회
        async INSURANCE_STAFF_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.insuranceList(payload)
                console.log('INSURANCE_STAFF_LIST info', res)
                if (res.data.status === 200) {
                    commit('INSURANCE_STAFF_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('INSURANCE_STAFF_LIST error', error)
            }
        },
        // @Description 기관 배상책임보험 직원 등록
        async REGIST_INSURANCE_STAFF({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.staffInsurance(payload)
                console.log('REGIST_INSURANCE_STAFF info', res)
                if (res.data.status === 201) {
                    commit('REGIST_INSURANCE_STAFF', {
                        info: payload.data,
                        idx: payload.idx
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_INSURANCE_STAFF error', error)
            }
        },
        // @Description 기관 배상책임보험 등록
        async REGIST_BRANCH_INSURANCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.insurance(payload)
                console.log('REGIST_BRANCH_INSURANCE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                        // commit('REGIST_BRANCH_INSURANCE', {
                        //     info: res.data.data.staffLiabilityInsurance,
                        //     idx: payload.liabilityInsuranceIdx
                        // })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_BRANCH_INSURANCE error', error)
            }
        },
        // @Description 기관 배상책임보험 파일삭제
        async DELETE_INSURANCE_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_INSURANCE_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_INSURANCE_FILE', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_INSURANCE_FILE error', error)
            }
        },
        // @Description 기관 그룹권한 조회
        async BRANCH_PERMISSION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.groups(payload)
                console.log('BRANCH_PERMISSION info', res)
                if (res.data.status === 200) {
                    commit('BRANCH_PERMISSION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_PERMISSION error', error)
            }
        },
        // @Description 기관 그룹권한 저장
        async REGIST_BRANCH_PERMISSION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.groups(payload)
                console.log('REGIST_BRANCH_PERMISSION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_BRANCH_PERMISSION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_BRANCH_PERMISSION error', error)
            }
        },
        // @Description 기관 그룹권한 삭제
        async DELETE_BRANCH_PERMISSION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.delete.groups(payload)
                console.log('DELETE_BRANCH_PERMISSION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_BRANCH_PERMISSION', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_BRANCH_PERMISSION error', error)
            }
        },
        // @Description 기관 급여설정 조회
        async BRANCH_SALARY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.salary(payload)
                console.log('BRANCH_SALARY info', res)
                if (res.data.status === 200) {
                    commit('BRANCH_SALARY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_SALARY error', error)
            }
        },
        // @Description 기관 급여설정 수정
        async UPDATE_BRANCH_SALARY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.salary(payload)
                console.log('UPDATE_BRANCH_SALARY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_BRANCH_SALARY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_BRANCH_SALARY error', error)
            }
        },
        // @Description 수급계약 조항설정 조회
        async BRANCH_SERVICE_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.contractService(payload)
                console.log('BRANCH_SERVICE_CONTRACT info', res)
                if (res.data.status === 200) {
                    commit('BRANCH_SERVICE_CONTRACT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_SERVICE_CONTRACT error', error)
            }
        },
        // @Description 수급계약 조할설정 수정
        async UPDATE_BRANCH_SERVICE_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.contractService(payload)
                console.log('UPDATE_BRANCH_SERVICE_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_BRANCH_SERVICE_CONTRACT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_BRANCH_SERVICE_CONTRACT error', error)
            }
        },
        // @Description 근로계약 조항설정 조회
        async BRANCH_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.contract(payload)
                console.log('BRANCH_CONTRACT info', res)
                if (res.data.status === 200) {
                    commit('BRANCH_CONTRACT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_CONTRACT error', error)
            }
        },
        // @Description 근로계약 조항설정 수정
        async UPDATE_BRANCH_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.contract(payload)
                console.log('UPDATE_BRANCH_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_BRANCH_CONTRACT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_BRANCH_CONTRACT error', error)
            }
        },
        // @Description 운영위원회 조항설정 조회
        async STEERING_COMMITTEE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.steeringCommittee(payload)
                console.log('STEERING_COMMITTEE info', res)
                if (res.data.status === 200) {
                    commit('STEERING_COMMITTEE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STEERING_COMMITTEE error', error)
            }
        },
        // @Description 운영위원회 조항설정 수정
        async UPDATE_STEERING_COMMITTEE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.steeringCommittee(payload)
                console.log('UPDATE_STEERING_COMMITTEE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_STEERING_COMMITTEE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_STEERING_COMMITTEE error', error)
            }
        },
        // @Description 파일읽기(공통)
        async READ_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.get.ruleRead(payload)
                console.log('READ_FILE info', res)
                if (res.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('READ_FILE error', error)
            }
        },
        // @Description 동기화 목록 조회 
        async SYNCING_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.resultState(payload)
                console.log('SYNCING_LIST info', res)
                if (res.data.status === 200) {
                    // store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                    commit('SYNCING_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SYNCING_LIST error', error)
            }
        },
        // @Description BO 동기화요청
        async ASYNC_BO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await sync.post.syncUpload(payload)
                console.log('ASYNC_BO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_BO error', error)
            }
        },
        // @Description 수급자목록 동기화
        async ASYNC_RECIPIENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.asyncRecipientsFile(payload)
                console.log('ASYNC_RECIPIENT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_RECIPIENT error', error)
            }
        },
        // @Description 직원목록 동기화
        async ASYNC_STAFF({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.asyncStaffsFile(payload)
                console.log('ASYNC_STAFF info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_STAFF error', error)
            }
        },
        // @Description 급여일정 동기화
        async ASYNC_SERVICE_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.asyncPlansMonthFile(payload)
                console.log('ASYNC_SERVICE_PLAN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_SERVICE_PLAN error', error)
            }
        },
        // @Description 급여제공내역 동기화
        async ASYNC_RFID({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.asyncRfidsMonthFile(payload)
                console.log('ASYNC_RFID info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_RFID error', error)
            }
        },
        // @Description 청구상세 동기화
        async ASYNC_CLAIM_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.asyncClaimDetailFile(payload)
                console.log('ASYNC_CLAIM_DETAIL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_CLAIM_DETAIL error', error)
            }
        },
        // @Description 급여비용 지급결정내역 동기화
        async ASYNC_LONG_WORK({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.asyncLongWorkAllowanceFile(payload)
                console.log('ASYNC_LONG_WORK info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_LONG_WORK error', error)
            }
        },
        // @Description W4C 직원 간편목록 업데이트
        async ASYNC_WFOURC_WORK({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.asyncStaffSimpleFile(payload)
                console.log('ASYNC_WFOURC_WORK info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_WFOURC_WORK error', error)
            }
        },
        // @Description 수급계약 일괄 엑셀 업로드
        async ASYNC_BATCH_RECIPIENT_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.asyncRecipientInfoFile(payload)
                console.log('ASYNC_BATCH_RECIPIENT_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_BATCH_RECIPIENT_CONTRACT error', error)
            }
        },
        // @Description 근로계약 일괄 엑셀 업로드
        async ASYNC_BATCH_EMPLOYMENT_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.asyncStaffContractFile(payload)
                console.log('ASYNC_BATCH_EMPLOYMENT_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_BATCH_EMPLOYMENT_CONTRACT error', error)
            }
        },
        // @Description 일괄수급계약 엑셀형식 파일 다운로드
        async ASYNC_RECIPIENT_CONTRACT_FORM({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.recipientInfoExcelDown(payload)
                console.log('ASYNC_BATCH_RECIPIENT_CONTRACT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_BATCH_RECIPIENT_CONTRACT error', error)
            }
        },
        // @Description 일괄근로계약 엑셀형식 파일 다운로드
        async ASYNC_EMPLOYMENT_CONTRACT_FORM({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.staffContratExcelDown(payload)
                console.log('ASYNC_BATCH_EMPLOYMENT_CONTRACT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ASYNC_BATCH_EMPLOYMENT_CONTRACT error', error)
            }
        },
        // @Description 물품목록관리 리스트 조회
        async MEDICINE_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.medicineInfo(payload)
                console.log('MEDICINE_INFO info', res)
                if (res.data.status === 200) {
                    commit('MEDICINE_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MEDICINE_INFO error', error)
            }
        },
        // @Description 물품목록관리 리스트 등록/수정
        async REGIST_MEDICINE_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.medicineInfo(payload)
                console.log('REGIST_MEDICINE_INFO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_MEDICINE_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MEDICINE_INFO error', error)
            }
        },
        // @Description 물품목록관리 리스트 삭제
        async DELETE_MEDICINE_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.delete.medicineInfo(payload)
                console.log('DELETE_MEDICINE_INFO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MEDICINE_INFO', payload.medicineInfoIdx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MEDICINE_INFO error', error)
            }
        },
        // @Description 기관 휴가설정관리(휴가유형) 조회
        async BRANCH_VACATION_TYPE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.vacationType(payload)
                console.log('BRANCH_VACATION_TYPE info', res)
                if (res.data.status === 200) {
                    commit('BRANCH_VACATION_TYPE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_VACATION_TYPE error', error)
            }
        },
        // @Description 기관 휴가유형 등록/수정
        async REGIST_BRANCH_VACATION_TYPE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.vacationType(payload)
                console.log('REGIST_BRANCH_VACATION_TYPE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_BRANCH_VACATION_TYPE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_BRANCH_VACATION_TYPE error', error)
            }
        },
        // @Description 기관 휴가유형 삭제
        async DELETE_BRANCH_VACATION_TYPE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.delete.vacationType(payload)
                console.log('DELETE_BRANCH_VACATION_TYPE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_BRANCH_VACATION_TYPE', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_BRANCH_VACATION_TYPE error', error)
            }
        },
        // @Description 기관 휴가설정관리(기관휴일) 조회
        async BRANCH_HOLIDAY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.holiday(payload)
                console.log('BRANCH_HOLIDAY info', res)
                if (res.data.status === 200) {
                    commit('BRANCH_HOLIDAY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_HOLIDAY error', error)
            }
        },
        // @Description 기관 기관휴일 등록/수정
        async REGIST_BRANCH_HOLIDAY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.holiday(payload)
                console.log('REGIST_BRANCH_HOLIDAY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_BRANCH_HOLIDAY', { data: res.data.data, date: payload.date })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_BRANCH_HOLIDAY error', error)
            }
        },
        // @Description 기관 기관휴일 삭제
        async DELETE_BRANCH_HOLIDAY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.delete.holiday(payload)
                console.log('DELETE_BRANCH_HOLIDAY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_BRANCH_HOLIDAY', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_BRANCH_HOLIDAY error', error)
            }
        },
        // @Description 기관 휴가규정 조회
        async BRANCH_VACATION_POLICY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.vacationPolicy(payload)
                console.log('BRANCH_VACATION_POLICY info', res)
                if (res.data.status === 200) {
                    commit('BRANCH_VACATION_POLICY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_VACATION_POLICY error', error)
            }
        },
        // @Description 기관 휴가규정 등록/수정
        async REGIST_VACATION_POLICY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.vacationPolicy(payload)
                console.log('REGIST_VACATION_POLICY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_VACATION_POLICY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_VACATION_POLICY error', error)
            }
        },
        // @Description 기관계좌정보 조회
        async BRANCH_ACCOUNT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.copayment(payload)
                console.log('BRANCH_ACCOUNT info', res)
                if (res.data.status === 200) {
                    commit('BRANCH_ACCOUNT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BRANCH_ACCOUNT error', error)
            }
        },
        // @Description 기관계좌정보 등록/수정
        async REGIST_BRANCH_ACCOUNT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                payload.secPno = payload.secPno ? btoa(payload.secPno.replace(/=/g, '')) : null
                payload.birthPno = payload.birthPno ? btoa(payload.birthPno.replace(/=/g, '')) : null
                payload.bankUserPw = payload.bankUserPw ? btoa(payload.bankUserPw.replace(/=/g, '')) : null
                res = await setting.post.copayment(payload)
                console.log('REGIST_BRANCH_ACCOUNT info', res)
                if (res.data.status === 201) {
                    if (payload.type !== 'useYn') {
                        store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    }
                    commit('REGIST_BRANCH_ACCOUNT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_BRANCH_ACCOUNT error', error)
            }
        },
        // @Description 기관계좌정보 삭제(사용안됫을 경우)
        async DELETE_BRANCH_ACCOUNT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.delete.copayment(payload)
                console.log('DELETE_BRANCH_ACCOUNT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_BRANCH_ACCOUNT', payload.customerBankAccountIdx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_BRANCH_ACCOUNT error', error)
            }
        },
        // @Description 4대보험요율 조회
        async DEDUCT_INSURANCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.deduct4Insure(payload)
                console.log('DEDUCT_INSURANCE info', res)
                if (res.data.status === 200) {
                    commit('DEDUCT_INSURANCE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DEDUCT_INSURANCE error', error)
            }
        },
        // @Description 서비스별 수가 조회
        async SALARY_NUMBER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.salaryNumber(payload)
                console.log('SALARY_NUMBER info', res)
                if (res.data.status === 200) {
                    commit('SALARY_NUMBER', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SALARY_NUMBER error', error)
            }
        },
        // @Description 시간대별 가산수가조회
        async NUMBER_HOURLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.numberHourly(payload)
                console.log('NUMBER_HOURLY info', res)
                if (res.data.status === 200) {
                    commit('NUMBER_HOURLY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('NUMBER_HOURLY error', error)
            }
        },
        // @Description 수가 기타가산설정 조회
        async STANDARD_SALARY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.standardSalary(payload)
                console.log('STANDARD_SALARY info', res)
                if (res.data.status === 200) {
                    commit('STANDARD_SALARY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STANDARD_SALARY error', error)
            }
        },
        // @Description 공통설정 대시보드
        async DASHBOARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.dash(payload)
                console.log('DASHBOARD info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASHBOARD error', error)
            }
        },
        // @Description 기타수당항목 명칭 조회
        async EXTRA_ALLOWANCE_TITLE_NAME({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.extraTitle(payload)
                console.log('EXTRA_ALLOWANCE_TITLE_NAME info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EXTRA_ALLOWANCE_TITLE_NAME error', error)
            }
        },
        // @Description 기타수당항목 명칭 변경
        async EXTRA_ALLOWANCE_REPLACE_NAME({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.extraTitle(payload)
                console.log('EXTRA_ALLOWANCE_REPLACE_NAME info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EXTRA_ALLOWANCE_REPLACE_NAME error', error)
            }
        },
        // @Description 기타공제항목 명칭 조회
        async EXTRA_DEDUCT_TITLE_NAME({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.deductEtcTitle(payload)
                console.log('EXTRA_DEDUCT_TITLE_NAME info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EXTRA_DEDUCT_TITLE_NAME error', error)
            }
        },
        // @Description 기타공제항목 명칭 변경
        async EXTRA_DEDUCT_REPLACE_NAME({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.deductEtcTitle(payload)
                console.log('EXTRA_DEDUCT_REPLACE_NAME info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EXTRA_DEDUCT_REPLACE_NAME error', error)
            }
        },
        // @Description 엑셀업로드로 물품 및 비품 등록하기
        async UPLOAD_MEDICINE_EXCEL_FORM({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.medicineInfoExcel(payload)
                console.log('UPLOAD_MEDICINE_EXCEL_FORM info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPLOAD_MEDICINE_EXCEL_FORM error', error)
            }
        },
        // @Description 맘스비 이용료 조회
        async PROD_SERVICE_FEE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.prodServiceFee(payload)
                console.log('PROD_SERVICE_FEE info', res)
                if (res.data.status === 200) {
                    commit('PROD_SERVICE_FEE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PROD_SERVICE_FEE error', error)
            }
        },
        // @Description 맘스비 이용료 메모조회
        async CUSTOMER_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.customerMemo(payload)
                console.log('CUSTOMER_MEMO info', res)
                if (res.data.status === 200) {
                    commit('CUSTOMER_MEMO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CUSTOMER_MEMO error', error)
            }
        },
        // @Description 맘스비 이용료 메모저장
        async REGIST_CUSTOMER_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.customerMemo(payload)
                console.log('REGIST_CUSTOMER_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_CUSTOMER_MEMO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_CUSTOMER_MEMO error', error)
            }
        },
        // @Description 맘스비 이용료 메모수정
        async UPDATE_CUSTOMER_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.post.customerMemo(payload)
                console.log('UPDATE_CUSTOMER_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_CUSTOMER_MEMO', {
                        idx:payload.boCustomerMemoIdx,
                        memo:res.data.data
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_CUSTOMER_MEMO error', error)
            }
        },
        // @Description 맘스비 이용료 메모삭제
        async DELETE_CUSTOMER_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.delete.customerMemo(payload)
                console.log('DELETE_CUSTOMER_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_CUSTOMER_MEMO', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_CUSTOMER_MEMO error', error)
            }
        },
    },
    getters: {
        DEFAULT_ADDRESS: state => {
            if (state.branchAddress) {
                let arr = state.branchAddress.filter(item => item.defaultYn === 'Y')
                return {
                    lat: arr[0].gpsLatitude,
                    lng: arr[0].gpsLongitude
                }
            } else {
                return null
            }
        },
        // VEHICLE_MAINTAIN: state => {
        //     if(state.maintainYear&&state.vehicleMaintain) {
        //         return state.vehicleMaintain.filter(item => item.carMaintenanceYmd.substr(0,4) === state.maintainYear)
        //     } else {
        //         return null
        //     }
        // },
        // VEHICLE_OPERATION: state => {
        //     if(state.operationYear&&state.vehicleOperation) {
        //         return state.vehicleOperation.filter(item => item.operationYmd.substr(0,4) === state.operationYear)
        //     } else {
        //         return null
        //     }
        // },
        BRANCH_INSURANCE: state => {
            if (state.staffLiabilityInsurance) {
                return state.staffLiabilityInsurance.sort(function(a, b) { return b.subscriptionYmd - a.subscriptionYmd })
            } else {
                return []
            }
        },
        DEDUCT_FILTER: state => {
            if (state.deduct4Insurance) {
                let copy = state.deduct4Insurance
                copy.forEach(item => {
                    item.total = item.worker + item.company
                })
                return copy
            } else {
                return null
            }
        },
        TIME_SALARY_FILTER: state => {
                if (state.numberHourly) {
                    let arr = []
                    let copy = state.numberHourly
                    arr.push(copy.slice(0, 6))
                    arr.push(copy.slice(6, 18))
                    arr.push(copy.slice(18, 22))
                    arr.push(copy.slice(22))
                    return arr
                } else {
                    return null
                }
            }
            // DEFAULT_RULE: state => {
            //     if(state.vacationPolicy) {
            //         return state.vacationPolicy
            //     } else {
            //         return {
            //             customerVacationPolicyIdx: 0,
            //             annualCalcDecimalCode: null,
            //             vacationApplyStandardCode: null
            //         }
            //     }
            // }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/settings.js